module.exports = "/images/vendor/flag-icon-css/flags/4x3/mx.svg?8ee3aa6a7feaf34c5cc806f645cfd3c6";